import React,{memo} from 'react';
import Chart from './Chart';

const ChartContainer = (props) => {
    return <Chart randomData={props.randomData}/>
};

export default memo(ChartContainer);